import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCardAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="34" height="34" rx="8" fill="#26C6DA" />
    <path d="M9.5 14.375H18.125" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12.5 20.375H14" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.875 20.375H18.875" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M24.5 17.0225V20.0825C24.5 22.715 23.8325 23.375 21.17 23.375H12.83C10.1675 23.375 9.5 22.715 9.5 20.0825V13.9175C9.5 11.285 10.1675 10.625 12.83 10.625H18.125" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M20.375 12.6875H24.5" stroke="white" stroke-width="1.5" stroke-linecap="round" />
    <path d="M22.4375 14.75V10.625" stroke="white" stroke-width="1.5" stroke-linecap="round" />
  </svg>
);
export default SvgCardAdd;
